import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { APIResponse } from '@yourcause/common';
import { I18nService } from '@yourcause/common/i18n';
import { NotifierService } from '@yourcause/common/notifier';
import { Observable, catchError, map, throwError } from 'rxjs';
import { NonprofitFeatureFlag } from './models';

/**
 * Nonprofit Feature Flags Resources
 */
@Injectable({ providedIn: 'root' })
export class NonprofitFeatureFlagsResources {

  constructor (
    private httpRestService: HttpRestService,
    private notifierService: NotifierService,
    private i18n: I18nService
  ) { }

  /**
   * Get Support Items
   *
   * @returns list of support items
   */
  getNonprofitFeatureFlags (): Observable<NonprofitFeatureFlag[]> {
    const endpoint = `api/NonprofitFeatureFlags`;

    return this.httpRestService.Get<APIResponse<NonprofitFeatureFlag[]>>(endpoint)
      .pipe(
        map(e => e.data),
        catchError(this.handleError.bind(this))
      );
  }

  /**
   * Display an error based on status code to the user.
   *
   * @param error http error thrown
   * @returns throws the error so that the caller can handle it
   */
  private handleError (error: any): Observable<never> {
    switch (error.status) {
      case 400:
        this.notifierService.error(error.error.detail);
        break;
      default:
        this.notifierService.error(this.i18n.translate(
          'error:textGeneric',
          {},
          'An error has occurred. Please try again later.'
        ));
        break;
    }

    return throwError(() => error);
  }
}
